import { AlignLeftOutlined, FilterOutlined, PrinterOutlined, SearchOutlined, SettingOutlined, UploadOutlined } from '@ant-design/icons'
import { Col, Radio, Row, Table } from 'antd'
import { BsPencil } from 'react-icons/bs'
import React from 'react'
import { useState } from 'react';
import images1 from '../../assets/images1.jfif'
import './EditStaffPolicies.css'
function EditStaffPolicies() {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [size, setSize] = useState("leave");

    const onChange = (e: RadioChangeEvent) => {
        setSize(e.target.value);
    };
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Leave Rule',
            dataIndex: 'leave',
        },
        {
            title: 'Atten.Rule',
            dataIndex: 'atten',
        },
        {
            title: 'Main Location',
            dataIndex: 'main',
        },
        {
            title: 'Payroll/Contractor',
            dataIndex: 'payroll',
        },
        {
            title: 'Weekly Off',
            dataIndex: 'attendance',
        },
        {
            title: 'Shift',
            dataIndex: 'shift',
        },
        {
            title: 'Action',
            dataIndex: 'action',
        },
    ];
    const data = [];
    for (let i = 0; i < 10; i++) {
        data.push({
            key: i,
            name: `Edward King ${i}`,
            leave: 'Rule 2',
            atten: 'Rule 2',
            main: '30',
            payroll: 'Payroll',
            attendance: "Atten.Taker",
            shift: 'Gen-A',
            action: <><BsPencil className='pen' /></>
        });
    }
    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const scroll = { y: 300 };
    return (
        <div>
            <Row className='mt-3'>
                <Col sm={14}>
                    <div className='flex justify-between'>
                        <PrinterOutlined className='edit-icon' />
                        <div>
                            <SearchOutlined className='edit-icon mr-1' />
                            <FilterOutlined className='edit-icon mr-1' />
                            <AlignLeftOutlined className='edit-icon mr-1' />
                            <UploadOutlined className='edit-icon mr-3' />
                            <SettingOutlined className='edit-icon' />
                        </div>
                    </div>
                    <div className='mt-2 edit-table'>
                        <Table rowSelection={rowSelection} columns={columns} dataSource={data} pagination={false} scroll={scroll} />
                    </div>
                </Col>
                <Col lg={10}>
                    <div className='edi-ass-back'>
                        <div className='edi-profile'>
                            <img className="edi-all-image" style={{ width: "40px", height: "40px" }} src={images1} alt="" />
                        </div>
                        <div className='edi-name'>
                            <p >Bhaskar Sharma</p>
                        </div>
                        <div className='edi-summary'>
                            <p >Guard | Security - Contractor | Lakshya Security</p>
                        </div>
                    </div>
                    <p className='edi-history'>History</p>
                    <div className='editabs'>
                        <div className='flex mt-2'>
                            <Radio.Group value={size} onChange={onChange} >
                                <Radio.Button value="leave">Leave Pplicy</Radio.Button>
                                <Radio.Button value="plicy">Attendance Policy</Radio.Button>
                                <Radio.Button value="main">Main Location</Radio.Button>
                                <Radio.Button value="payroll">Payroll</Radio.Button>
                                <Radio.Button value="contractor">Contractor</Radio.Button>
                                <Radio.Button value="shift">Shift</Radio.Button>
                                <Radio.Button value="weekly">Weekly Off</Radio.Button>
                            </Radio.Group>
                        </div>
                    </div>
                    <div className='edi-Taker'>
                        <Row className='bo-bo-edi'>
                            <Col lg={14}>
                                <div className='ml-2'>
                                    <Row>
                                        <Col sm={4}>
                                            <img className="hisimage" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

                                        </Col>
                                        <Col sm={20} className='mt-1'>
                                            <p style={{ fontSize: "10px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                            <p style={{ fontSize: "8px" }}>Guard | Security - Contractor | Lakshya Security</p>
                                        </Col>
                                    </Row>
                                </div>

                            </Col>
                            <Col lg={10}>
                                <div className='mr-2'>
                                    <p className='edi-enabled'>Lorem 2 Policy</p>
                                    <p className='edi-tack-date'>12 August 2023</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className='bo-bo-edi'>
                            <Col lg={14}>
                                <div className='ml-2'>
                                    <Row>
                                        <Col sm={4}>
                                            <img className="hisimage" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

                                        </Col>
                                        <Col sm={20} className='mt-1'>
                                            <p style={{ fontSize: "10px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                            <p style={{ fontSize: "8px" }}>Guard | Security - Contractor | Lakshya Security</p>
                                        </Col>
                                    </Row>
                                </div>

                            </Col>
                            <Col lg={10}>
                                <div className='mr-2'>
                                    <p className='edi-enabled'>Lorem 1 Policy</p>
                                    <p className='edi-tack-date'>12 August 2023</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className='bo-bo-edi'>
                            <Col lg={14}>
                                <div className='ml-2'>
                                    <Row>
                                        <Col sm={4}>
                                            <img className="hisimage" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

                                        </Col>
                                        <Col sm={20} className='mt-1'>
                                            <p style={{ fontSize: "10px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                            <p style={{ fontSize: "8px" }}>Guard | Security - Contractor | Lakshya Security</p>
                                        </Col>
                                    </Row>
                                </div>

                            </Col>
                            <Col lg={10}>
                                <div className='mr-2'>
                                    <p className='edi-enabled'>Lorem 1 Policy</p>
                                    <p className='edi-tack-date'>12 August 2023</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className='bo-bo-edi'>
                            <Col lg={14}>
                                <div className='ml-2'>
                                    <Row>
                                        <Col sm={4}>
                                            <img className="hisimage" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

                                        </Col>
                                        <Col sm={20} className='mt-1'>
                                            <p style={{ fontSize: "10px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                            <p style={{ fontSize: "8px" }}>Guard | Security - Contractor | Lakshya Security</p>
                                        </Col>
                                    </Row>
                                </div>

                            </Col>
                            <Col lg={10}>
                                <div className='mr-2'>
                                    <p className='edi-enabled'>Lorem 1 Policy</p>
                                    <p className='edi-tack-date'>12 August 2023</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className='bo-bo-edi'>
                            <Col lg={14}>
                                <div className='ml-2'>
                                    <Row>
                                        <Col sm={4}>
                                            <img className="hisimage" style={{ width: "30px", height: "30px" }} src={images1} alt="" />

                                        </Col>
                                        <Col sm={20} className='mt-1'>
                                            <p style={{ fontSize: "10px", fontWeight: "bold" }}>Bhaskar Sharma</p>
                                            <p style={{ fontSize: "8px" }}>Guard | Security - Contractor | Lakshya Security</p>
                                        </Col>
                                    </Row>
                                </div>

                            </Col>
                            <Col lg={10}>
                                <div className='mr-2'>
                                    <p className='edi-enabled'>Lorem 1 Policy</p>
                                    <p className='edi-tack-date'>12 August 2023</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default EditStaffPolicies